import React from 'react';

const GlobeUnFilledIcon = ({ size, ...props }) => (
<svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M8.00004 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33334 8.00004 1.33334C4.31814 1.33334 1.33337 4.3181 1.33337 8C1.33337 11.6819 4.31814 14.6667 8.00004 14.6667Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M5.33336 2H6.00002C4.70002 5.89333 4.70002 10.1067 6.00002 14H5.33336" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M10 2C11.3 5.89333 11.3 10.1067 10 14" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M2 10.6667V10C5.89333 11.3 10.1067 11.3 14 10V10.6667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M2 6C5.89333 4.7 10.1067 4.7 14 6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

);

export default GlobeUnFilledIcon;
